import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = "/otp";
// const REST_API_BASE_URL = "/api";

export const requestOtp = (email) => {
    return axiosInstance.post(`${REST_API_BASE_URL}/request-otp`, { email });
};

export const verifyOtpAndResetPassword = (email, otp, newPassword) => {
    return axiosInstance.post(`${REST_API_BASE_URL}/verify-otp`, { email, otp, newPassword });
};
